import { useFormContext, useWatch } from 'react-hook-form';
import { ui } from '@procuros/datachecks';

import { useErrorContext } from 'contexts/ErrorsNavigationContext/ErrorsNavigationContext';
import { WebEDIError } from 'services/webediErrors/types';
import { DisplayModes } from 'components/DataTable/Types';
import { DataDisplay } from 'components/Form/DataDisplay/DataDisplay';
import { SchemableFormTextarea } from 'components/Form/SchemableFormTextarea/SchemableFormTextarea';
import { useFieldState } from 'components/SchemableForm/hooks/useFieldState';
import { Translate } from 'components/Translate/Translate';

type LongTextFieldProps = {
  field: ui.LongTextField;
  fieldId: string;
  isReadOnly: boolean;
  mode: DisplayModes;
  variant?: 'large';
};

export const LongTextField = ({ field, fieldId, isReadOnly, mode, variant }: LongTextFieldProps) => {
  const value = useWatch({ name: fieldId });
  const { register } = useFormContext();
  const { service } = useErrorContext<WebEDIError>();
  const error = service.useErrorById(fieldId);
  const numberOfErrors = service.useNumberOfActiveErrors();
  const setCurrentError = service.setCurrentError;
  const fieldState = useFieldState(fieldId, error);

  if (mode === DisplayModes.view) {
    return (
      <DataDisplay
        value={value}
        label={field.label}
        totalNumberOfErrors={numberOfErrors}
        error={error}
        fieldId={fieldId}
        onShowFieldErrorModal={() => error && setCurrentError(error)}
        description={field.description}
      />
    );
  }

  return (
    <SchemableFormTextarea
      label={field.label}
      description={field.description ? <Translate i18nKey={field.description} /> : undefined}
      error={error}
      totalNumberOfErrors={numberOfErrors}
      {...register(fieldId)}
      value={value}
      onShowFieldErrorModal={() => error && setCurrentError(error)}
      required={field.modality === 'MANDATORY'}
      disabled={isReadOnly}
      variant={variant}
      fieldState={fieldState}
    />
  );
};
